export const UserInfoService = Symbol.for('UserInfoService');
